/*
 * @Author: liyifan
 * @Date: 2025-10-28 17:42:29
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-11-24 10:37:48
 */

import { shopifyCartAdd } from '@utils/api.js'

if (!customElements.get("v5-pdp-variant-compare")) {
  class V5PdpVariantCompare extends HTMLElement {
    constructor() {
      super();
      this.DOM = {
        addToCartList: [],
      };
      this.isMobile = window.innerWidth < 1024;
      this.size = Number(this.getAttribute("data-size")) || 0;
      this._handlers = new Map();
    }
    connectedCallback() {
      this.DOM.addToCartList = this.querySelectorAll("[compare-add-to-cart]");
      this.bindEvents();
      // pc端 > 3 或 MB大于1时，启用swiper
      if ((!this.isMobile && Number(this.size) > 3) || (this.isMobile && Number(this.size) > 1)) this.initSwiper();
    }
    disconnectedCallback() {
      this.unbindEvents();
    }
    bindEvents() {
      const handler = (e) => {
        const btn = e.target.closest("[compare-add-to-cart]");
        if (btn) this.addToCart(btn);
      };
      this.addEventListener("click", handler);
      this._handlers.set(this, handler);
    }
    unbindEvents() {
      const handler = this._handlers.get(this);
      if (handler) this.removeEventListener("click", handler);
      this._handlers.clear();
    }
    async addToCart(el) {
      el.classList.add('loading')
      const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      try {
        const { id, title, spu_title } = el.dataset;
        const items = [{ id, quantity: 1 }]
        const res = await shopifyCartAdd({items});
        if (cart?.renderContents) {
          cart.renderContents(res);
        } else {
          window.location.href = "/cart";
        }
        const gaParams = {
          product_spu_name: spu_title,
          module: "ProductsCompare_2",
          position: title,
          button_name: "AddToCart",
        }
        gaPushDataLayer('5.0_products_details_page_user_clicks', gaParams);
      } catch (e) {
        e?.statusText && pushErrorMessage(e.statusText);
      } finally {
        el.classList.remove('loading')
        cart?.classList.contains("is-empty") && cart.classList.remove("is-empty");
      }
    }
    initSwiper() {
        const swiperEl = this.querySelector(".v5-pdp-variant-compare-swiper");
        if (!swiperEl) return;

        // 避免重复初始化
        if (swiperEl.swiper) return;

        new Swiper(swiperEl, {
          slidesPerView: 1.25,
          spaceBetween: 24,
          loop: true,
          simulateTouch: true,
          touchStartPreventDefault: false,
          passiveListeners: true,
          breakpoints: {
            1024: {
              slidesPerView: 3.14,
            },
          },
          navigation: !this.isMobile
            ? {
                nextEl: this.querySelector(".v5-pdp-variant-compare-swiper-button-next"),
                prevEl: this.querySelector(".v5-pdp-variant-compare-swiper-button-prev"),
              }
            : false,
        });
    }
  }
  customElements.define("v5-pdp-variant-compare", V5PdpVariantCompare);
}
